import { jsx as _jsx } from "react/jsx-runtime";
import '../styles/SurveyPage.css';
import Survey from '../../../shared/components/Survey';
import { buildQuestionKey, submitSurveyResponses, } from '../api/surveyResponses';
import { trackPostSurveySubmitClicked, trackPreSurveySubmitClicked, } from '../tracking';
const SurveyPage = ({ surveyUrl, surveyType, sessionId, eventSlug, joinCode, onComplete, }) => {
    const handleSurveySubmit = async (answers) => {
        if (surveyType === 'pre') {
            trackPreSurveySubmitClicked(joinCode);
        }
        else {
            trackPostSurveySubmitClicked(joinCode);
        }
        if (!sessionId || !joinCode) {
            throw new Error('Missing session data. Please rejoin the class.');
        }
        // Fetch survey data again to get questions for submission
        const response = await fetch(surveyUrl);
        if (!response.ok) {
            throw new Error('Failed to load survey data');
        }
        const surveyData = await response.json();
        await submitSurveyResponses({
            sessionId,
            eventSlug,
            joinCode,
            questions: surveyData.questions,
            answers,
            surveyType,
            getQuestionKey: buildQuestionKey,
        });
        onComplete();
    };
    return (_jsx("div", { className: "survey-page", children: _jsx(Survey, { surveyUrl: surveyUrl, onSubmit: handleSurveySubmit, showHeader: true }) }));
};
export default SurveyPage;
